import { Box, Card, Heading, Text, VStack } from '@chakra-ui/react'
import type { LucideIcon } from 'lucide-react'
import {
  ArrowLeftRight,
  BarChart3,
  Bell,
  Cpu,
  Eye,
  Globe,
  Layers,
  Lock,
  MapPin,
  Monitor,
  Network,
  Route,
  Shield,
  ShieldCheck,
  Sun,
  Thermometer,
  WifiOff,
  Wrench,
  Zap,
} from 'lucide-react'
import type { ValueProposition } from '@/data/business-value'
import { cardHover } from '~/components/shell'

const iconMap: Record<string, LucideIcon> = {
  Network,
  Eye,
  ShieldCheck,
  Cpu,
  ArrowLeftRight,
  Layers,
  Sun,
  Wrench,
  MapPin,
  BarChart3,
  WifiOff,
  Monitor,
  Thermometer,
  Shield,
  Zap,
  Globe,
  Lock,
  Route,
  Bell,
}

interface ValuePropositionCardProps {
  proposition: ValueProposition
  color?: string
}

export default function ValuePropositionCard({
  proposition,
  color = 'blue.500',
}: ValuePropositionCardProps) {
  const Icon = iconMap[proposition.icon] || Network

  return (
    <Card.Root overflow="hidden" transition="all 0.3s" _hover={cardHover} cursor="default" h="100%">
      <Card.Body p={6}>
        <VStack gap={3} align="start">
          <Box p={3} borderRadius="xl" bg={`${color}/10`} color={color}>
            <Icon size={24} />
          </Box>
          <Heading size="sm">{proposition.title}</Heading>
          <Text fontSize="sm" color="content.secondary">
            {proposition.description}
          </Text>
        </VStack>
      </Card.Body>
    </Card.Root>
  )
}
